import TaskEditorPage from '../editor';

export default function PublicTasksDemoPage() {
  return <TaskEditorPage publicDemo />;
}
